import { render, staticRenderFns } from "./Skewness.vue?vue&type=template&id=ec489ce6&scoped=true"
import script from "./Skewness.vue?vue&type=script&lang=js"
export * from "./Skewness.vue?vue&type=script&lang=js"
import style0 from "./Skewness.vue?vue&type=style&index=0&id=ec489ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec489ce6",
  null
  
)

export default component.exports